// @flow
import * as React from 'react';
import { useIntl } from 'react-intl';
import * as yup from 'yup';

import type { PrismicWhitePaperForm } from '~schema';

import type { DownloadFormValues } from './types';
import messages from './messages';

const useDownloadFormValidationSchema = (node: ?PrismicWhitePaperForm) => {
  const intl = useIntl();
  return React.useMemo(
    () =>
      yup.object<DownloadFormValues>({
        name: yup
          .string()
          .required(
            node?.data?.error_required?.text ||
              intl.formatMessage(messages.errors.required),
          ),
        email: yup
          .string()
          .required(
            node?.data?.error_required?.text ||
              intl.formatMessage(messages.errors.required),
          )
          .email(
            node?.data?.error_required?.text ||
              intl.formatMessage(messages.errors.email),
          ),
        phone: yup
          .string()
          .required(
            node?.data?.error_required?.text ||
              intl.formatMessage(messages.errors.required),
          ),
        acceptPrivacyPolicy: yup
          .boolean()
          .test(
            'isTrue',
            node?.data?.error_must_accept_privacy_policy?.text ||
              intl.formatMessage(messages.errors.mustAcceptPrivacyPolicy),
            value => value === true,
          ),
        inputSector: yup.string().nullable(true),
      }),
    [node],
  );
};

export default useDownloadFormValidationSchema;
